const awsExports = {
    Auth: {
      Cognito: {
        region: "ap-southeast-2",
        userPoolId: "ap-southeast-2_cWxHExKRg",
        userPoolClientId: "deqi7eig3k2a6c6kdvhju9n67",
      }
    }
  };
  export default awsExports;